<template>
    <DsModal
        id="campaign-builder-process-modal"
        class="process-modal"
        :is-open="isOpen"
        :dialog="dialog"
        :show-close="showClose"
        :show-save="showSave"
        :size="size"
        :title="title"
        @close="close"
    >
        <template #header>
            <div class="header-menu">
                <slot name="additionalHeaderContent" class="additional-content" />
                <DsFilledButton
                    v-if="visibleSaveButton"
                    :disabled="!showSave"
                    data-qa="process-modal-save-button"
                    class="save-button"
                    @click="save"
                >
                    {{ actionButtonLabel || $options.MESSAGE_CONSTANTS.actionButtonLabel }}
                </DsFilledButton>
            </div>
        </template>

        <template #default>
            <DsInlineAlert
                v-if="showWarning"
                class="modal-warning"
                data-qa="process-modal-warning-alert"
                :type="alertType"
                leading-icon
            >
                {{ warningText }}
            </DsInlineAlert>
            <div v-if="summaryText" class="process-summary">
                <div class="process-summary-label">
                    {{ $options.MESSAGE_CONSTANTS.summaryLabel }}
                </div>

                <div class="process-summary-text">
                    {{ summaryText }}
                </div>
            </div>

            <div class="process-configuration">
                <slot name="processParameters" />
            </div>

            <div v-if="showWarningIcon">
                <DsInlineAlert leading-icon type="warning">
                    {{ processTipText }}
                </DsInlineAlert>
            </div>
            <div v-else-if="!showWarningIcon && processTipText" class="process-tip">
                <div class="process-tip-icon">
                    <DsIcon name="info-circle" />
                </div>

                <div class="process-tip-text">
                    {{ processTipText }}
                    <div>
                        <DsFilledButton
                            v-if="processTipLink"
                            class="process-tip-button"
                            as="a"
                            :href="processTipLink"
                            target="_blank"
                            trailing-icon="external-link"
                        >
                            <div>
                                {{ $options.MESSAGE_CONSTANTS.processTipLinkLabel }}
                            </div>
                        </DsFilledButton>
                    </div>
                </div>
            </div>
        </template>
    </DsModal>
</template>

<script>
export const MESSAGE_CONSTANTS = {
    actionButtonLabel: 'Save',
    processTipLinkLabel: 'Learn more',
    summaryLabel: 'Summary',
};

export default {
    MESSAGE_CONSTANTS,

    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        dialog: {
            type: Boolean,
            default: true,
        },
        processTipLink: {
            type: String,
            default: '',
        },
        processTipText: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: 'med',
        },
        showClose: {
            type: Boolean,
            default: true,
        },
        showSave: {
            type: Boolean,
            default: true,
        },
        summaryText: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            required: true,
        },
        actionButtonLabel: {
            type: String,
            default: null,
        },
        showWarningIcon: {
            type: Boolean,
            default: false,
        },
        visibleSaveButton: {
            type: Boolean,
            default: true,
        },
        showWarning: {
            type: Boolean,
            default: false,
        },
        alertType: {
            type: String,
            default: 'critical',
        },
        warningText: {
            type: String,
            default: '',
        },
    },
    emits: ['close-modal', 'update-config'],
    methods: {
        close() {
            this.$emit('close-modal');
        },

        save() {
            this.$emit('update-config');
        },
    },
};
</script>

<style lang="scss">
.process-modal .modal-body {
    padding: 0;
}
#campaign-builder-process-modal.process-modal .modal-body {
    padding: 0;
}

#campaign-builder-process-modal.process-modal .modal-dialog.med.dialog {
    min-height: auto;
}
</style>

<style lang="scss" scoped>
.process-modal {
    --modal-padding: #{0 $spacing-300 $spacing-300};
}

.process-modal .modal-dialog.med.dialog {
    min-height: auto;
    padding: 0;
}

.modal-warning {
    margin-top: $spacing-200;
    margin-bottom: $spacing-200;
}

.process-summary {
    margin-top: $spacing-250;
}

.process-summary-label {
    font-size: $font-size-xs;
    color: $color-ink-800;
}

.process-summary-text {
    padding-top: $spacing-100;
    padding-bottom: $spacing-100;
    margin-bottom: $spacing-200;
}

.process-tip {
    display: flex;
    padding: $spacing-150;
    border-radius: $spacing-100;
    flex-wrap: wrap;
    justify-items: left;
    background-color: $color-blue-050;
}

.process-tip-icon {
    flex: 6%;
    color: $color-blue-300;
}

.process-tip-text {
    margin-top: 2px;
    flex: 94%;
    color: $color-ink-900;
}

.process-tip-button {
    height: 32px;
    margin: 8px 0;
    padding: 8px 12px 8px 8px;
    border-radius: 8px;
    color: $color-ink-900;
    background-color: $color-ink-100;
}

.header-menu {
    display: flex;
    flex-wrap: wrap;
}

.modal-body {
    padding: 0;
}

</style>
